import React from 'react'

import History from '@/Helpers/History'
import useTranslation from '@/Hooks/UseTranslation'
import ContentHeader from '@/Layouts/MainLayout/components/ContentHeader'
import { PROGRAMMATION_NAVIGATION, ProgrammationTab } from './programmation-navigation'

interface Props {
  activeTab: ProgrammationTab
  children: React.ReactNode
  projectId: string
  subtitle?: string
}

const ProgrammationHeader = ({ activeTab, children, projectId, subtitle }: Props) => {

  const { t } = useTranslation()

  const tabs = PROGRAMMATION_NAVIGATION.map((tab) => ({
    label: t(tab.translationKey),
    icon: <i className={tab.icon} />,
    onClick: () => History.push(`/project/${projectId}${tab.path}`),
    active: activeTab === tab.id,
    disabled: !projectId,
  }))

  return (
    <ContentHeader
      className="pl4-programmation-header pl4-page-header"
      title={t('NAVIGATION:Programmation')}
      subtitle={subtitle}
      navTabs={tabs}
    >
      {children}
    </ContentHeader>
  )
}

export default ProgrammationHeader
